/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Form_H2Inputs */

const es_cap_form_h2 = /** @type {(inputs: Cap_Form_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de alta como capitán.`)
};

const gl_cap_form_h2 = /** @type {(inputs: Cap_Form_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de alta como patrón.`)
};

const en_cap_form_h2 = /** @type {(inputs: Cap_Form_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up as a skipper.`)
};

/**
* | output |
* | --- |
* | "Sign up as a skipper." |
*
* @param {Cap_Form_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_form_h2 = /** @type {((inputs?: Cap_Form_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Form_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_form_h2(inputs)
	if (locale === "en") return en_cap_form_h2(inputs)
	return es_cap_form_h2(inputs)
});